/* eslint-disable @typescript-eslint/no-unused-vars */
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { useGetElcByIdQuery } from 'redux/apiSlice/elcs.slice';
import { TRtkErrorType } from '@packages/utils';
import PageWrapper from 'components/Base/PageWrapper';
import { RoutesPaths } from 'routes/Routes.types';
import { Lightning, ActionPlan as ActionPlanIcon } from 'assets/icon/icon';
import Button from 'components/Base/Button/Button';
import TacticTable from './TacticTaskTable/TacticTable';
import CardContent from '../../../../components/Base/Layout/Content/CardContent';
import PageHeader from './PageHeader';

const ActionPlan = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { id } = params;

  const isFromMyELC = useMemo(
    () => location.pathname.includes('/my-elc/'),
    [location.pathname],
  );

  const { data, isLoading, error } = useGetElcByIdQuery({
    elcId: id as string,
  });

  const paths = useMemo(() => {
    if (!id) return null;

    const basePath = isFromMyELC ? RoutesPaths.MYELCS : RoutesPaths.ELCS;
    const detailPath = isFromMyELC
      ? `/app/${RoutesPaths.MYELCS_DETAIL.replace(':id', id)}`
      : `/app/${RoutesPaths.ELC_DETAIL.replace(':id', id)}`;

    const pillarRoutePath = isFromMyELC
      ? RoutesPaths.MYELCS_PILLARS_OF_STRENGTH
      : RoutesPaths.ELC_PILLARS_OF_STRENGTH;

    const pillarsPath = `/app/${pillarRoutePath}`
      .replace(':id', id)
      .replace(':pillarId', id);

    return {
      base: `/app/${basePath}`,
      detail: detailPath,
      pillars: pillarsPath,
    };
  }, [id, isFromMyELC]);

  const handleBack = () => {
    if (!paths) {
      navigate(
        isFromMyELC ? `/app/${RoutesPaths.MYELCS}` : `/app/${RoutesPaths.ELCS}`,
      );
      return;
    }
    navigate(paths.detail);
  };

  const handlePillarsClick = () => {
    if (!paths) return;
    navigate(paths.pillars);
  };

  return (
    <PageWrapper
      title={data?.name || ''}
      backButton={{
        labelPrefix: data?.name || '',
        tooltip: 'Back to Details',
        onClick: handleBack,
      }}
      isLoading={isLoading}
      error={error as TRtkErrorType}
      actions={
        <Button
          variant="default"
          onClick={handlePillarsClick}
          icon={<Lightning size={14} />}
          data-cy="pillars_btn"
        >
          Pillars
        </Button>
      }
    >
      <>
        <PageHeader
          subtitle="Action Plan"
          subtitleIcon={<ActionPlanIcon size={16} />}
        />
        <CardContent>
          <TacticTable />
        </CardContent>
      </>
    </PageWrapper>
  );
};

export default ActionPlan;
